import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SystemsNotificationsComponent } from '../SystemNotifications/components/SystemNotifications/systems-notifications.component';
import { AccountManagementComponent } from '../AccountManagement/components/account-management.component';
import { AdminRouteGuard } from './services/admin-route-guard.service';
import { AdminAccountPreferencesComponent } from '../AccountManagement/components/AccountPreferences/admin-account-preferences.component';
import { UserProfilePageComponent } from '../AccountManagement/components/UserProfile/UserProfilePage/user-profile-page.component';
import { AccountManagementRouteGuard } from './services/account-management-route-guard.service';

const adminRoutes: Routes = [
    {
        path: 'AccountManagement',
        component: AccountManagementComponent,
        canActivate: [AccountManagementRouteGuard],
        children: [
            {
                path: 'account/:accountId',
                component: AdminAccountPreferencesComponent
            },
            {
                path: 'user',
                component: UserProfilePageComponent
            },
            {
                path: 'user/:userId',
                component: UserProfilePageComponent
            }
        ]
    },
    {
        path: 'Notifications',
        component: SystemsNotificationsComponent,
        canActivate: [AdminRouteGuard]
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(adminRoutes)
    ],
    exports: [
        RouterModule
    ],
    providers: [
        AdminRouteGuard, AccountManagementRouteGuard
    ]
})
export class AdminRoutingModule { }
